import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { getPropsBlocker, makePropList } from '../../../utils';
import { typography } from '../../../system/mixins';
import { paddingAttributes } from '../../../system';
var propertyList = makePropList(['enableVerticalScroll']);
export var DialogContentRoot = styled.div.withConfig(getPropsBlocker(propertyList))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    ", "\n    ", "\n    ", ";\n"])), typography('paragraphLarge'), function (_ref) {
  var enableVerticalScroll = _ref.enableVerticalScroll;
  return enableVerticalScroll ? 'overflow-y: auto;' : '';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.componentOverrides.DialogContent.Root.base;
}, paddingAttributes);